/**
 * Error de un campo concreto, como valor y no como texto.
 *
 * Que sea un valor y no un mensaje permite (a) probar las reglas sin tocar la UI, (b) localizar
 * los textos en la capa de presentación y (c) que un 422 del servidor se pinte con el mismo
 * mecanismo que una validación local: el usuario ve el error debajo del campo en ambos casos.
 */
export const FIELD_ERRORS = [
  'NAME_REQUIRED',
  'NAME_LENGTH',
  'PHONE_REQUIRED',
  'PHONE_FORMAT',
  'EMAIL_REQUIRED',
  'EMAIL_FORMAT',
  'DATE_PAST',
  'DATE_TOO_FAR',
  'TIME_PAST',
  'TIME_CLOSED',
  'PARTY_MIN',
  'PARTY_MAX',
  'NOTES_LENGTH',
  'TERMS_REQUIRED',
  'UNKNOWN',
] as const;

export type FieldError = (typeof FIELD_ERRORS)[number];

/** Mapea los códigos que acordamos con el backend (ver docs/ANALISIS.md §9). */
export function fieldErrorFromServerCode(code: string): FieldError {
  const match = FIELD_ERRORS.find((error) => error.toLowerCase() === code.trim().toLowerCase());
  return match ?? 'UNKNOWN';
}

/** Campos del formulario de reserva, usados como clave de los mapas de error. */
export const BookingField = {
  NAME: 'name',
  PHONE: 'phone',
  EMAIL: 'email',
  DATE: 'date',
  TIME: 'time',
  PARTY_SIZE: 'partySize',
  NOTES: 'notes',
  TERMS: 'terms',
} as const;

export type BookingFieldKey = (typeof BookingField)[keyof typeof BookingField];

export type FieldErrors = Partial<Record<string, FieldError>>;
